import { useQuery } from '@tanstack/react-query'
import getFeedbackSurveyResponse from '../api/feedback/getFeedbackSurveyResponse'
import { GET_FEEDBACK_SURVEY_RESPONSE_KEY } from '../constants'

const useFeedbackSurveyResponse = (isActive: boolean, surveyId: string) => {
  return useQuery(
    [GET_FEEDBACK_SURVEY_RESPONSE_KEY, surveyId],
    () => getFeedbackSurveyResponse(surveyId),
    {
      enabled: isActive,
    },
  )
}

export default useFeedbackSurveyResponse
